import { Component } from '@angular/core';
import { NavParams, NavController, PopoverController } from 'ionic-angular';

import { Account } from '../../model/account';

import { VideoPopupPage } from './video-popup';

@Component({
    selector: 'page-videos',
    templateUrl: 'videos.html'
})
export class VideosPage {
    account: Account;
    popoverActive: boolean;

    constructor(navParams : NavParams, private popupCtrl : PopoverController, private nav: NavController) {
        this.account = navParams.get("account");
    }


    showVideoPopup(video) {
        if (this.popoverActive)
			return;

		this.popoverActive = true;

        let popover = this.popupCtrl.create(VideoPopupPage, {
            video: video
        }, { cssClass: 'page-video-popup' });
    
        popover.present();

        popover.onDidDismiss((data) => {
            this.popoverActive = false;
        })
    }

    back() {
        this.nav.pop();
    }
}



// WEBPACK FOOTER //
// ./src/pages/videos/videos.ts